import { BRAND_COLORS } from '../theme';
import { STATUS, SURFACE, TEXT } from '../brand-tokens';

export const COLORS = {
  light: {
    primary: {
      lighter: "#58C3BE",
      light: "#58C3BE",
      main: BRAND_COLORS.teal,
      dark: BRAND_COLORS.teal,
      darker: BRAND_COLORS.teal,
      contrastText: "#FFFFFF",
      mainChannel: "27 129 135",
      lightChannel: "88 195 190",
      darkChannel: "27 129 135"
    },
    secondary: {
      lighter: BRAND_COLORS.lightYellow,
      light: BRAND_COLORS.lightYellow,
      main: BRAND_COLORS.yellow,
      dark: BRAND_COLORS.yellow,
      darker: BRAND_COLORS.yellow,
      contrastText: BRAND_COLORS.darkTeal,
      mainChannel: "236 191 43",
      lightChannel: "252 242 141",
      darkChannel: "236 191 43"
    },
    info: {
      lighter: "#B2DFDB",
      light: "#4DB6AC",
      main: "#009688",
      dark: "#00796B",
      darker: "#004D40",
      contrastText: "#FFFFFF",
      mainChannel: "0 150 136",
      lightChannel: "77 182 172",
      darkChannel: "0 121 107"
    },
    success: {
      lighter: "#E0F7F7",
      light: "#80E5E5",
      main: STATUS.light.success.text,
      dark: "#80E5E5",
      darker: "#E0F7F7",
      contrastText: "#ffffff",
      mainChannel: "0 95 110",
      lightChannel: "128 229 229",
      darkChannel: "128 229 229"
    },
    warning: {
      lighter: "#FFF5CC",
      light: "#FFD666",
      main: STATUS.light.warning.text,
      dark: "#FFD666",
      darker: "#FFF5CC",
      contrastText: "#1C252E",
      mainChannel: "255 171 0",
      lightChannel: "255 214 102",
      darkChannel: "255 214 102"
    },
    error: {
      lighter: BRAND_COLORS.lightYellow,
      light: BRAND_COLORS.lightYellow,
      main: BRAND_COLORS.yellow,
      dark: BRAND_COLORS.yellow,
      darker: BRAND_COLORS.yellow,
      contrastText: "#FFFFFF",
      mainChannel: "236 191 45",
      lightChannel: "252 242 141",
      darkChannel: "236 191 45"
    },
    grey: {
      "50": "#FFFBFB",
      "100": "#F2F2F2",
      "200": "#F2F2F2",
      "300": "#DFE3E8",
      "400": "#C4CDD5",
      "500": "#919EAB",
      "600": "#637381",
      "700": "#454F5B",
      "800": "#1C252E",
      "900": "#141A21",
      "500Channel": "145 158 171"
    },
    surface: {
      main: "#F2F2F2",
      light: "#F2F2F2",
      dark: "#F2F2F2",
      contrastText: BRAND_COLORS.darkTeal,
      mainChannel: "242 242 242"
    },
    common: {
      black: "#000000",
      white: "#FFFFFF",
      blackChannel: "0 0 0",
      whiteChannel: "255 255 255"
    },
    button: {
      main: BRAND_COLORS.teal,
      disabled: "#C4CDD5",
      mainChannel: "27 129 135",
      contrastText: "#FFFFFF"
    }
  },
  dark: {
    primary: {
      lighter: "#58C3BE",
      light: "#58C3BE",
      main: BRAND_COLORS.teal,
      dark: BRAND_COLORS.teal,
      darker: BRAND_COLORS.teal,
      contrastText: "#FFFFFF",
      mainChannel: "27 129 135",
      lightChannel: "88 195 190",
      darkChannel: "27 129 135"
    },
    secondary: {
      lighter: BRAND_COLORS.lightYellow,
      light: BRAND_COLORS.lightYellow,
      main: BRAND_COLORS.yellow,
      dark: BRAND_COLORS.yellow,
      darker: BRAND_COLORS.yellow,
      contrastText: BRAND_COLORS.darkTeal,
      mainChannel: "236 191 43",
      lightChannel: "252 242 141",
      darkChannel: "236 191 43"
    },
    info: {
      lighter: "#004D40",
      light: "#00796B",
      main: "#009688",
      dark: "#4DB6AC",
      darker: "#B2DFDB",
      contrastText: "#FFFFFF",
      mainChannel: "0 150 136",
      lightChannel: "77 182 172",
      darkChannel: "0 121 107"
    },
    success: {
      lighter: "#00373F",
      light: "#004B56",
      main: STATUS.dark.success.text,
      dark: "#80E5E5",
      darker: "#E0F7F7",
      contrastText: "#FFFFFF",
      mainChannel: "0 95 110",
      lightChannel: "128 229 229",
      darkChannel: "128 229 229"
    },
    warning: {
      lighter: "#7A4100",
      light: "#B76E00",
      main: STATUS.dark.warning.text,
      dark: "#FFD666",
      darker: "#FFF5CC",
      contrastText: "#FFFFFF",
      mainChannel: "255 171 0",
      lightChannel: "255 214 102",
      darkChannel: "255 214 102"
    },
    error: {
      lighter: BRAND_COLORS.lightYellow,
      light: BRAND_COLORS.lightYellow,
      main: BRAND_COLORS.yellow,
      dark: BRAND_COLORS.yellow,
      darker: BRAND_COLORS.yellow,
      contrastText: "#FFFFFF",
      mainChannel: "236 191 45",
      lightChannel: "252 242 141",
      darkChannel: "236 191 45"
    },
    grey: {
      "50": BRAND_COLORS.darkTeal,
      "100": BRAND_COLORS.teal,
      "200": BRAND_COLORS.teal,
      "300": TEXT.dark.primary,
      "400": TEXT.dark.secondary,
      "500": TEXT.dark.tertiary,
      "600": TEXT.dark.quaternary,
      "700": SURFACE.dark.active,
      "800": SURFACE.dark.hover,
      "900": SURFACE.dark.app,
      "500Channel": "122 139 146"
    },
    surface: {
      main: BRAND_COLORS.teal,
      light: BRAND_COLORS.teal,
      dark: BRAND_COLORS.teal,
      contrastText: "#F2F2F2",
      mainChannel: "23 128 134"
    },
    common: {
      black: "#FFFFFF",
      white: "#000000",
      blackChannel: "255 255 255",
      whiteChannel: "0 0 0"
    },
    button: {
      main: BRAND_COLORS.teal,
      disabled: TEXT.dark.tertiary,
      mainChannel: "173 250 246",
      contrastText: "#FFFFFF"
    }
  }
};

import { varAlpha, createPaletteChannel } from '../styles';
// ----------------------------------------------------------------------

// Create palette channels for both light and dark modes
const createModePalette = (mode) => {
  const colors = COLORS[mode];
  
  return {
    primary: createPaletteChannel(colors.primary),
    secondary: createPaletteChannel(colors.secondary),
    info: createPaletteChannel(colors.info),
    success: createPaletteChannel(colors.success),
    warning: createPaletteChannel(colors.warning),
    error: createPaletteChannel(colors.error),
    grey: createPaletteChannel(colors.grey),
    common: createPaletteChannel(colors.common),
    button: createPaletteChannel(colors.button),
  };
};

// Text colors for both modes
export const text = {
  light: createPaletteChannel({
    primary: BRAND_COLORS.darkTeal,
    secondary: '#091C23',
    disabled: COLORS.light.grey[500],
  }),
  dark: createPaletteChannel({
    primary: '#FFFFFF',
    secondary: '#FFFFFF',
    disabled: '#94A3B8',
  }),
};

// Background colors for both modes
export const background = {
  light: createPaletteChannel({
    paper: '#F2F7F7',
    default: '#F7F8FA',
    neutral: COLORS.light.grey[200],
  }),
  dark: createPaletteChannel({
    paper: BRAND_COLORS.darkTeal,
    default: BRAND_COLORS.darkTeal,
    neutral: BRAND_COLORS.teal,
  }),
};

// Action colors for both modes
export const action = {
  light: {
    hover: varAlpha(COLORS.light.grey['500Channel'] || COLORS.light.grey[500], 0.08),
    selected: varAlpha(COLORS.light.grey['500Channel'] || COLORS.light.grey[500], 0.16),
    focus: varAlpha(COLORS.light.grey['500Channel'] || COLORS.light.grey[500], 0.24),
    disabled: varAlpha(COLORS.light.grey['500Channel'] || COLORS.light.grey[500], 0.8),
    disabledBackground: varAlpha(COLORS.light.grey['500Channel'] || COLORS.light.grey[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
    active: COLORS.light.grey[600],
  },
  dark: {
    hover: varAlpha(COLORS.dark.grey['500Channel'] || COLORS.dark.grey[500], 0.08),
    selected: varAlpha(COLORS.dark.grey['500Channel'] || COLORS.dark.grey[500], 0.16),
    focus: varAlpha(COLORS.dark.grey['500Channel'] || COLORS.dark.grey[500], 0.24),
    disabled: varAlpha(COLORS.dark.grey['500Channel'] || COLORS.dark.grey[500], 0.8),
    disabledBackground: varAlpha(COLORS.dark.grey['500Channel'] || COLORS.dark.grey[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
    active: COLORS.dark.grey[500],
  },
};

// Create complete palettes for both modes
export const createLightPalette = () => {
  const baseColors = createModePalette('light');
  
  return {
    ...baseColors,
    text: text.light,
    background: background.light,
    action: action.light,
    divider: varAlpha(COLORS.light.grey['500Channel'] || COLORS.light.grey[500], 0.2),
  };
};

export const createDarkPalette = () => {
  const baseColors = createModePalette('dark');
  
  return {
    ...baseColors,
    text: text.dark,
    background: background.dark,
    action: action.dark,
    divider: varAlpha(COLORS.dark.grey['500Channel'] || COLORS.dark.grey[500], 0.2),
  };
};

// Legacy exports for backward compatibility
export const grey = createPaletteChannel(COLORS.light.grey);
export const primary = createPaletteChannel(COLORS.light.primary);
export const secondary = createPaletteChannel(COLORS.light.secondary);
export const info = createPaletteChannel(COLORS.light.info);
export const success = createPaletteChannel(COLORS.light.success);
export const warning = createPaletteChannel(COLORS.light.warning);
export const error = createPaletteChannel(COLORS.light.error);
export const common = createPaletteChannel(COLORS.light.common);
export const button = createPaletteChannel(COLORS.light.button);

export const basePalette = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  common,
  button,
  divider: varAlpha(COLORS.light.grey['500Channel'] || COLORS.light.grey[500], 0.2),
  action,
};

export const lightPalette = createLightPalette();
export const darkPalette = createDarkPalette();

// ----------------------------------------------------------------------

export const colorSchemes = {
  light: { palette: lightPalette },
  dark: { palette: darkPalette },
};
